import React from 'react';

import _, { flowRight as compose } from 'lodash';
import { inject, observer } from 'mobx-react';
import moment from 'moment-timezone';
import { withRouter } from 'providers';
import Slider from 'react-slick';

import AxlButton from 'AxlMUIComponent/AxlButton';
import AxlDialog from 'components/AxlDialog';
import AssignmentMap from '../AssignmentMap';
import * as E from './styles';
import { Box, Button } from '@mui/material';

export default class AddressHistoryList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalSelected: null,
      modalAddressSelected: null,
    };
  }

  toggleModalPreview = (id) => {
    this.setState({ modalSelected: this.state.modalSelected !== id ? id : null });
  };

  toggleAddressLocation = (id) => {
    this.setState({ modalAddressSelected: this.state.modalAddressSelected !== id ? id : null });
  };

  render() {
    const { results } = this.props;

    return results.map((result, i) => (
      <E.Container key={`result-${i}`}>
        <E.Row>
          <E.Date>
            {_.defaultTo(result.shipment?.dropoff_latest_ts && moment(result.shipment.dropoff_latest_ts).format('MM/DD/YYYY'), '-')}
            <E.HL>{_.get(result, 'shipment.id', '-')}</E.HL>
          </E.Date>
          <E.Flex />
          <E.StatusText>{`${_.get(result, 'shipment.status', '-')} ${_.defaultTo(result.shipment?.dropoff_latest_ts && '@' + moment(result.shipment.dropoff_latest_ts).format('HH:mmA'), '-')}`}</E.StatusText>
        </E.Row>
        <E.Box>
          <E.Row>
            <E.ClientContainer>
              <E.ClientAvatar src={_.get(result, 'client.logo_url', `/assets/images/logo.png`)} width={25} />
            </E.ClientContainer>
            <E.Flex>
              <E.PadContainer>
                <E.CustomerName>{_.get(result, 'shipment.customer.name', '-')}</E.CustomerName>
                <E.Label>Drop-off note:</E.Label>
                <E.Text>{_.get(result, 'shipment.dropoff_note', '-')}</E.Text>
                <E.Label>Access code:</E.Label>
                <E.Text>{_.get(result, 'shipment.dropoff_access_code', '-')}</E.Text>
                <E.Label>Additional Instructions:</E.Label>
                <E.Text>{_.get(result, 'shipment.dropoff_additional_instruction', '-')}</E.Text>
              </E.PadContainer>
            </E.Flex>
            <E.Link>
              <E.PadContainer onClick={() => this.toggleAddressLocation(i)}>{`Pin`}</E.PadContainer>
              <AxlDialog
                isOpen={this.state.modalAddressSelected === i}
                handleClose={() => this.toggleAddressLocation(i)}
                childrenTitle="Address Location"
                maxWidth="md"
              >
                <AddressLocation {...result} />
              </AxlDialog>
            </E.Link>
            <E.ImageContainer>
              {_.get(result, 'pod.images', []) && (
                <E.ImagePreview
                  src={_.get(result, 'pod.images', []) ? _.get(result, 'pod.images[0].url', []) : `/assets/images/logo.png`}
                  width={40}
                  onClick={() => this.toggleModalPreview(i)}
                />
              )}
              <AxlDialog
                isOpen={this.state.modalSelected === i}
                handleClose={() => this.toggleModalPreview(i)}
                childrenTitle="Image Preview"
                maxWidth="md"
              >
                <AddressHistoryImagePreview {...result} />
              </AxlDialog>
            </E.ImageContainer>
          </E.Row>
        </E.Box>
      </E.Container>
    ));
  }
}

class AddressHistoryImagePreviewCompose extends React.Component {
  sendToCustomer = (text) => {
    const { messengerStore, shipment } = this.props;
    if (!text) return;

    messengerStore.refType = '';
    messengerStore.generateTopic();
    // copyToClipboard(text);
  };

  render() {
    const { dropoff } = this.props;
    const picturies = _.get(this.props, 'pod.images', []);
    const isShow = !!picturies.length;
    const settings = {
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      adaptiveHeight: false,
    };
    const driverId = _.get(dropoff, 'driver_id', null);
    const isShowSendButton = driverId;

    return (
      <E.SliderContainer>
        {isShow && (
          <Slider {...settings}>
            {picturies.map((image, index) => (
              <div key={`image-${index}`}>
                <E.SliderInner>
                  <E.ImageSliderContainer>
                    <E.ImagePreview src={image.url} alt="" />
                  </E.ImageSliderContainer>
                  <E.DescContainer>{`Photo taken @ ${moment(image._created).format('MM/DD/YYYY HH:mmA')} - [${_.get(image, 'event.location.geolocation.latitude', '-')} ${_.get(image, 'event.location.geolocation.longitude', '')}]`}</E.DescContainer>
                  <E.ButtonContainer>
                    <AxlButton compact disabled={!driverId} onClick={() => this.sendToCustomer(image.url)}>{`Send Photo to Driver`}</AxlButton>
                  </E.ButtonContainer>
                </E.SliderInner>
              </div>
            ))}
          </Slider>
        )}
      </E.SliderContainer>
    );
  }
}
export const AddressHistoryImagePreview = compose(withRouter, inject('messengerStore'), observer)(AddressHistoryImagePreviewCompose);

class AddressLocationCompose extends React.Component {
  componentDidMount() {
    const { messengerStore, dropoff } = this.props;
    if (dropoff) {
      messengerStore.setStopSelected(dropoff);
      messengerStore.loadPodsByStop();
    }
  }

  sendToDriver = () => {
    const { messengerStore } = this.props;
    const { pods = [] } = messengerStore;
    if (!pods.length) return;
  };

  render() {
    const { shipment, messengerStore } = this.props;
    const { pods = [], assignmentInfoInTopicSelected } = messengerStore;

    return (
      <Box>
        <Box height={'200px'} width={'100%'}>
          <AssignmentMap pods={pods} shipment={shipment} />
        </Box>
        <E.DescContainer>{`Photo taken @ ${_.get(pods, '[0].event.ts') ? moment(_.get(pods, '[0].event.ts')).format('MM/DD/YYYY HH:mmA') : '-'} - [${_.get(pods, '[0]event.location.geolocation.latitude', '-')} ${_.get(pods, '[0]event.location.geolocation.longitude', '-')}]`}</E.DescContainer>
        <E.ButtonContainer onClick={this.sendToDriver}>
          <Button variant="contained" color="primary" size='small' disableElevation>
            Send Dropoff Pin to Driver
          </Button>
        </E.ButtonContainer>
      </Box>
    );
  }
}
export const AddressLocation = compose(withRouter, inject('messengerStore'), observer)(AddressLocationCompose);
